/**
 * Created by eungkyu on 2016. 3. 15..x
 */
window.vvBrowser = (function(window) {
    var m = {};

    var cached = {};
    function getCached(key, checker) {
        if (cached[key] == null)
            cached[key] = checker();
        return cached[key];
    }

    m.isChrome = function() {
        return getCached('chrome', function() {
            return /(Chrome|CriOS)\//.test(window.navigator.userAgent);
        });
    };

    m.isSafari = function() {
        return getCached('safari', function() {
            return /Safari\//.test(window.navigator.userAgent) && /Apple Computer/.test(window.navigator.vendor);
        });
    };

    m.isiOSBuiltIn = function() {
        return getCached('iosinapp', function() {
            return /(iPhone|iPod|iPad).*AppleWebKit(?!.*Version)/i.test(navigator.userAgent);
        });
    };

    m.isFirefox = function() {
        return getCached('firefox', function() {
            return /Firefox[\/\s](\d+\.\d+)/.test(window.navigator.userAgent);
        });
    };

    m.isIe = function() {
        return getCached('ie', function() {
            return /(MSIE|Trident)/.test(window.navigator.userAgent);
        });
    };

    m.isMobile = function() {
        return getCached('mobile', function() {
            var a = window.navigator.userAgent || window.navigator.vendor || window.opera;
            return /android|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(ad|hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|symbian|treo|up.(browser|link)|vodafone|wap|webos|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|e-|e\/|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(di|rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|xda(-|2|g)|yas-|your|zeto|zte-/i.test(a.substr(0, 4));
        });
    };

    m.isAndroid = function() {
        return getCached('android', function() {
            var a = window.navigator.userAgent || window.navigator.vendor || window.opera;
            return /android/i.test(a)
        });
    };

    m.isiOS = function() {
        return getCached('ios', function() {
            var a = window.navigator.userAgent || window.navigator.vendor || window.opera;
            return /ip(ad|hone|od)/i.test(a)
        });
    };

    m.isFacebookBuiltIn = function() {
        return getCached('facebook', function() {
            return /\b\;FBAV\//.test(window.navigator.userAgent);
        });
    };

    m.isTwitterBuiltIn = function() {
        return getCached('twitter', function() {
            return /Twitter for iPhone/.test(window.navigator.userAgent);
        });
    };

    m.isKakaoTalkBuiltIn = function() {
        return getCached('kakaoTalk', function() {
            return /\bKAKAOTALK\b/.test(window.navigator.userAgent);
        });
    };

    m.isBandBuiltIn = function() {
        return getCached('band', function() {
            return /BAND/.test(window.navigator.userAgent);
        });
    };

    m.isWeiBoBuiltIn = function() {
        return getCached('weibo', function() {
            return /Weibo/.test(window.navigator.userAgent);
        });
    };

    m.isWeChatBuiltIn = function() {
        return getCached('wechat', function() {
            return /\bMicroMessenger\//.test(window.navigator.userAgent);
        });
    };

    m.isCoohuaBuiltIn = function() {
        return getCached('coohua', function() {
            return /Coohua/.test(window.navigator.userAgent);
        });
    };


    m.isQQBuiltIn = function() {
        return getCached('qq', function() {
            return /\bQQ\//.test(window.navigator.userAgent);
        });
    };

    m.isQZoneBuiltIn = function() {
        return getCached('qzone', function() {
            return /\bQzone\//.test(window.navigator.userAgent);
        });
    };

    m.isLineBuiltIn = function() {
        return getCached('line', function() {
            return /Line\//.test(window.navigator.userAgent);
        });
    };

    m.isPseudoMetaEnabled = function() {
        return getCached('pseudo-meta', function() {
            return /\b(MicroMessenger|QQ|Qzone)\b/.test(window.navigator.userAgent);
        });
    };

    m.isPopupDisabled = function() {
        return getCached('no-popup', function() {
            return /\b(\;FBAV|MicroMessenger|QQ|Qzone|Twitter|KAKAOTALK|KAKAOSTORY|BAND|Coohua)\b/.test(window.navigator.userAgent);
        });
    };

    m.chromeVersion = function() {
        return getCached('chrome-version', function() {
            var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
            return raw ? parseInt(raw[2], 10) : false;
        });
    };

    m.isWechatAdDisable = function() {
        return getCached('wechat-ad-disable', function() {
            var raw = navigator.userAgent.match(/MicroMessenger\/([0-9]+)\.([0-9]+)\.([0-9]+)/);
            return raw ? raw[1] == 6 && raw[2] >= 3 && raw[3] >= 22 && raw[3] < 25: false;
        });
    };

    m.getBuiltInApp = function() {
        return getCached('builtinapp', function() {
            if (m.isFacebookBuiltIn())
                return 'facebook';
            if (m.isTwitterBuiltIn())
                return 'twitter';
            if (m.isKakaoTalkBuiltIn())
                return 'kakaotalk';
            if (m.isBandBuiltIn())
                return 'band';
            if (m.isWeChatBuiltIn())
                return 'weibo';
            if (m.isCoohuaBuiltIn())
                return 'coohua';
            if (m.isQQBuiltIn())
                return 'qq';
            if (m.isQZoneBuiltIn())
                return 'qzone';
            if (m.isLineBuiltIn())
                return 'line';
            return '';
        });
    };

    m.getLanguage = function() {
        return window.navigator.language || window.navigator.userLanguage;
    };

    return m;
})(window);

window.vv = (function(window, $) {

    function safeString(s) {
        if (typeof s == 'string')
            return s;
        else
            return '';
    }

    function getOrigin(location) {
        if (location == null)
            location = window.location;
        var hostname = location.hostname;
        if (hostname == 'm.vonvon.me') {
            hostname = 'kr.vonvon.me';
        }
        return location.protocol + '//' + hostname + (location.port ? ':' + location.port : '');
    }

    function parseQuery(query) {
        if (!query)
            return {};

        if (query.charAt(0) == '?')
            query = query.substring(1);

        return query.split('&').reduce(function(map, param) {
            var arr = param.split('=');
            map[arr[0]] = decodeURIComponent(arr[1] || '');
            return map;
        }, {});
    }

    function getMetaData(name) {
        var value =  $("meta[property='" + name + "']").attr("content");
        return safeString(value);
    }

    function setMetaData(name, value) {
        $("meta[property='" + name + "']").remove();
        var meta = window.document.createElement('meta');
        meta.setAttribute('property', name);
        meta.setAttribute('content', value);
        $('head').append(meta);
    }

    var vvMeta = null;
    function readVvMetaData() {
        if (vvMeta == null) {
            var json = getMetaData('vv');
            vvMeta = json ? JSON.parse(json) : {};
        }
    }

    function getVvMetaData(name) {
        readVvMetaData();
        return vvMeta[name];
    }

    function setVvMetaData(name, value) {
        readVvMetaData();
        vvMeta[name] = value;
    }

    function parseUrl(url) {
        var parser = window.document.createElement('a');
        if (url != null)
            parser.href = url;
        return parser;
    }

    function getPath(location) {
        return location.pathname + location.search + location.hash;
    }

    function parseSearch(search) {
        if (search && search[0] == '?')
            search = search.substring(1);
        let r = {};
        if (!search)
            return r;
        angular.forEach(search.split('&'), function (token) {
            var pair = token.split('=');
            if (pair.length == 1) {
                r[decodeURIComponent(pair[0])] = null;
            } else {
                r[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            }
        });
        return r;
    }

    function buildSearch(params) {
        if (params == null)
            return '';

        var tokens = [];
        for (var name in params) {
            if (params.hasOwnProperty(name) && params[name] != null) {
                tokens.push(encodeURIComponent(name) + '=' + encodeURIComponent(params[name]));
            }
        }

        return tokens.join('&');
    }

    function uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    function appendSearchToPath(path, params) {
        if (path.indexOf('?') > -1)
            return path + '&' + buildSearch(params);
        else
            return path + '?' + buildSearch(params);
    }

    function land(region, use_replace) {
        if (vvGa)
            vvGa.sendEvent('GNB', 'language', region);

        var stage = getVvMetaData('stage');
        var host_pat = getVvMetaData('host_pat') || '##.vonvon.me';
        if (stage == 'real') {
            if (region == 'cn')
                host_pat = 'cn.vonvon.net';
            else
                host_pat = '##.vonvon.me';
        }
        var url = 'http://' + host_pat.replace('##' + '.', region + '.') + '/';

        if (use_replace) {
            window.location.replace(url);
        } else {
            window.location.href = url;
        }
    }

    function getDomainByLang(lang, stage) {
        var subdomains = ['kr', 'jp', 'en', 'la', 'it', 'th', 'tr'];

        lang = lang.replace('pt', 'br');

        var c = subdomains.indexOf(lang.split('-')[0]);
        var l = subdomains.indexOf(lang.split('-')[1]);
        var domain = '.vonvon.me';

        if (stage != 'real')
            domain = '.' + stage + domain;

        if (c >= 0)
            domain = subdomains[c] + domain;
        else if (l >= 0)
            domain = subdomains[l] + domain;
        else
            return null;

        if (stage == 'dev')
            domain = domain + ':8080';

        return domain;
    }

    return {
        safeString: safeString,
        getOrigin: getOrigin,
        parseQuery: parseQuery,
        parseSearch: parseSearch,
        getMetaData: getMetaData,
        setMetaData: setMetaData,
        getVvMetaData: getVvMetaData,
        setVvMetaData: setVvMetaData,
        parseUrl: parseUrl,
        getPath: getPath,
        buildSearch: buildSearch,
        appendSearchToPath: appendSearchToPath,
        land: land,
        getDomainByLang: getDomainByLang,
        uuidv4, uuidv4,
    };
})(window, window.jQuery);

window.vvUtils = (function(window) {
    function getSnsFromSnsId(sns_id) {
        var arr = sns_id.split(':', 2);
        if (arr.length == 2) {
            if (arr[0] == 'twt')
                return 'twitter';
            else if (arr[0] == 'wb')
                return 'weibo';
            else
                return arr[0];
        }

        if (sns_id.length == 32)
            return 'anonymous';
        else
            return 'facebook';
    }

    function uuid() {
        var format = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
        var id = format.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16|0;
            var v = (c == 'x') ? r : (r&0x3|0x8);

            return v.toString(16);
        });

        return id;
    }

    function getWildMainDomain(hostpart){
        var hostsplit = hostpart.split('.');
        if( hostsplit.length <= 1 || hostsplit[1] != 'cn' ){
            return;
        }
        hostsplit.shift();
        return '.' + hostsplit.join('.')
    }

    function arrRemoveDuplicates(arr) {
        var uniqArr = arr.reduce(function (a, b) {
            if (a.indexOf(b) < 0)
                a.push(b);
            return a;
        }, []);

        return uniqArr;
    }

    return {
        getSnsFromSnsId: getSnsFromSnsId,
        getWildMainDomain: getWildMainDomain,
        uuid: uuid,
        arrRemoveDuplicates: arrRemoveDuplicates
    };
})(window);

window.urlbase64 = (function() {
    return {
        encode: function(s) {
            return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        },
        decode: function(b) {
            return decodeURIComponent(escape(atob(b.replace(/_/g, '/').replace(/-/g, '+'))));
        },
        encodeJson: function(o) {
            return btoa(unescape(encodeURIComponent(JSON.stringify(o)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        },
        decodeJson: function(b) {
            return JSON.parse(decodeURIComponent(escape(atob(b.replace(/_/g, '/').replace(/-/g, '+')))));
        }
    };
})();

window.vvCookies = (function(window) {
    // 현재 쿠키 설정시 지역별 설정을 위해 regionalDomains에 추가함
    // 그리고 real이 아닌 경우 쿠키 이름에 stage prefix를 붙임 (개발/베타에서 리얼 쿠키 읽히지 않도록)
    // (prefix가 없는 쿠키를 지우고 prefixed 쿠키를 구움 - 마이그레이션 때문에)

    // 주의: 쿠키 이름 convention을 고치면 util.py의 set|get|remove_vv_cookie도 고쳐야 함

    // TODO
    // global 쿠키와 regional 쿠키 분리 필요 (글로벌 로그인 등에 필요)

    var module = {};
    var scat = vv.getVvMetaData('scat');
    var region = vv.getVvMetaData('service_name');
    var stage = vv.getVvMetaData('stage');

    var scopeGlobal = 'global';
    var scopeLocal = 'local';

    function getStageSubdomains() {
        var stageSubdomains;
        if (stage == 'real')
            stageSubdomains = [];
        else if (stage == 'dev')
            stageSubdomains = ['dev', 'dev2'];
        else
            stageSubdomains = [stage];

        var vvDomain = vv.getVvMetaData('domain');
        var vvExtra = ('.' + vvDomain).match(/\.vonvon\.me$/) ? vvDomain.replace(/\.?vonvon\.me$/, '') : '';
        if (stageSubdomains && vvExtra && stageSubdomains.indexOf(vvExtra) < 0)
            stageSubdomains.push(vvExtra);

        return stageSubdomains;
    }

    function getBaseDomain() {
        var hostname = window.location.hostname;
        if (region != 'cn') {
            var domains = ['vonvon.me', 'vonvon.net'].filter(function (domain) {
                return hostname.indexOf(domain) >= 0;
            });
        } else {
            var domains = ['wechatmenia.cn', 'wuxia100.com', 'vonvon.net', 'vonvon.cc', 'vonvon.me'].filter(function(domain) {
                return hostname.indexOf(domain) >= 0;
            });
        }
        if (domains.length == 0)
            return hostname;

        var domain = domains[0];
        var subDomains = getStageSubdomains().filter(function(subDomain) {
            return hostname.indexOf(subDomain + '.' + domain) >= 0;
        });

        if (subDomains.length == 0)
            return domain;

        return subDomains[0] + '.' + domain;
    }

    var globalDomain = null;
    function getGlobalDomain() {
        if (globalDomain == null) {
            globalDomain = '.' + getBaseDomain();
            console.log('cookie global domain', globalDomain);
        }
        return globalDomain;
    }

    var regionalDomain = null;
    function getRegionalDomain() {
        if (regionalDomain == null) {
            var baseDomain = getBaseDomain();
            if (scat == 'vonvon')
                regionalDomain = '.' + region.replace('la', 'es') + '.' + baseDomain;
            else
                regionalDomain = '.' + baseDomain;
            console.log('cookie regional domain', regionalDomain);
        }
        return regionalDomain;
    }

    function getKeys(scope, name) {
        var keyTokens = [];

        if (scope == scopeLocal)
            keyTokens.push(region.replace('la', 'es'));
        if (stage != 'real')
            keyTokens.push(stage);
        keyTokens.push(name);

        var key = keyTokens.join('.');

        var keys = [key];
        if (stage == 'real' && key != name) {
            keys.push(name);
        }

        return keys;
    }

    function getByKeys(keys) {
        for (var i = 0; i < keys.length; i++) {
            var value = docCookies.getItem(keys[i]);
            if (value != null)
                return value;
        }

        return null;
    }

    function setByKeys(keys, value, domain, expires) {
        if (expires == null) {
            var d = new Date();
            d.setDate(d.getDate() + 30);
            expires = d;
        } else if (expires == 'session') {
            expires = null;
        }
        docCookies.setItem(keys[0], value, expires, '/', domain);
        for (var i = 1; i < keys.length; i++) {
            docCookies.removeItem(keys[i], '/', domain);
        }
    }

    function removeByKeys(keys, domain) {
        for (var i = 0; i < keys.length; i++) {
            docCookies.removeItem(keys[i], '/', domain);
        }
    }

    function getDefaultDomain(scope) {
        if (scope == scopeGlobal) {
            return getGlobalDomain();
        }
        return getRegionalDomain();
    }

    function addMethods(obj, scope) {
        obj.get = function (name) {
            var keys = getKeys(scope, name);
            return getByKeys(keys);
        };

        obj.getJson = function (name) {
            return JSON.parse(obj.get(name));
        };

        obj.set = function (name, value, domain, expires) {
            var keys = getKeys(scope, name);
            if (region == 'cn'){
                var hostname = window.location.hostname;
                var wild_domain = vvUtils.getWildMainDomain(hostname);
                if (wild_domain) {
                    setByKeys(keys, value, wild_domain, expires);
                    return;
                } else if (hostname.indexOf('cn.') == 0) {
                    setByKeys(keys, value, hostname, expires);
                    return;
                }
            }
            domain = domain || getDefaultDomain(scope);
            setByKeys(keys, value, domain, expires);
        };

        obj.setJson = function (name, value, domain, expires) {
            obj.set(name, JSON.stringify(value), domain, expires);
        };

        obj.remove = function (name, domain) {
            var keys = getKeys(scope, name);
            if (region == 'cn'){
                var hostname = window.location.hostname;
                var wild_domain = vvUtils.getWildMainDomain(hostname);
                if (wild_domain) {
                    removeByKeys(keys, wild_domain);
                    return;
                } else if (hostname.indexOf('cn.') == 0) {
                    removeByKeys(keys, hostname);
                    return;
                }
            }
            domain = domain || getDefaultDomain(scope);
            removeByKeys(keys, domain);
        };

        obj.getOrMigrate = function (name, srcObjList, domain, expires) {
            var value = obj.get(name);

            for (var i = 0; value == null && i < srcObjList.length; i++) {
                value = srcObjList[i].get(name);
                if (value != null) {
                    obj.set(name, domain, expires);
                    srcObjList[i].remove(name);
                }
            }
            return value;
        };

        obj.getShareAutoCookieName = function(quiz_id) {
            //return 'sh_' + quiz_id + '_op';
            // semi auto cookie name
            return 'ssh_' + quiz_id + '_opm';
        };
    }

    addMethods(module, scopeLocal);

    module.global = {};
    addMethods(module.global, scopeGlobal);

    return module;
})(window);

window.vvSessionStorage = (function(window) {
    var module = {};
    var isSessionStorageAvailable = function() {
        try {
            if (!window.sessionStorage) return false;
            window.sessionStorage.setItem('test', '1');
            window.sessionStorage.removeItem('test');
            return true;
        } catch (error) {
            return false;
        }
    };

    if (!isSessionStorageAvailable()) {
        console.warn('no session storage, use cookies instead');
        var storage;
        try {
            storage = JSON.parse(urlbase64.decode(vvCookies.get('sessionStorage'))) || {};
        } catch (e) {
            console.log('error decoding session storage');
            storage = {};
        }

        module.get = function(name) {
            return storage[name];
        };

        module.getAndRemove = function(name) {
            var value = storage[name];
            delete storage[name];
            vvCookies.set('sessionStorage', urlbase64.encode(JSON.stringify(storage)), null, 'session');
            return value;
        };

        module.set = function(name, value) {
            storage[name] = value;
            vvCookies.set('sessionStorage', urlbase64.encode(JSON.stringify(storage)), null, 'session');
        };

        module.remove = function(name) {
            delete storage[name];
            vvCookies.set('sessionStorage', urlbase64.encode(JSON.stringify(storage)), null, 'session');
        };

        module.clear = function() {
            storage = {};
            vvCookies.remove('sessionStorage');
        };
        return module;
    }

    module.get = function(name) {
        try {
            var v = JSON.parse(window.sessionStorage.getItem(name));
            // console.log('ss-get', name, v);
            return v;
        } catch (e) {
            console.log('vvSessionStorage get error', e);
            return null;
        }
    };

    module.getAndRemove = function(name) {
        try {
            var value = JSON.parse(window.sessionStorage.getItem(name));
            window.sessionStorage.removeItem(name);
            // console.log('ss-getAndRemove', name, value);
            return value;
        } catch (e) {
            console.log('vvSessionStorage getAndRemove error', e);
            return null;
        }
    };

    module.set = function(name, value) {
        try {
            // console.log('ss-set', name, value);
            window.sessionStorage.setItem(name, JSON.stringify(value));
        } catch(e) {
            console.log('vvSessionStorage set error', e);
        }
    };

    module.remove = function(name) {
        try {
            // console.log('ss-remove', name);
            window.sessionStorage.removeItem(name);
        } catch(e) {
            console.log('vvSessionStorage remove error', e);
        }
    };

    module.clear = function() {
        try {
            // console.log('ss-clear');
            window.sessionStorage.clear();
        } catch(e) {
            console.log('vvSessionStorage clear error', e);
        }
    };

    return module;
})(window);

window.vvSessionUtils = (function (sessionStorage) {
    return {
        getLastUploadedProfile: function () {
            return sessionStorage.get('last_uploaded_profile_v2');
        },
        getUploadedProfileIfExisted: function (defaultImageUrl) {
            var imageUrl = sessionStorage.get('uploaded_profile_v2');
            return (imageUrl) ? imageUrl : defaultImageUrl;
        },
        setUploadedProfile: function (imageUrl) {
            sessionStorage.set('uploaded_profile_v2', imageUrl);
            sessionStorage.set('last_uploaded_profile_v2', imageUrl);
        },
        removeUploadedProfile: function() {
            sessionStorage.remove('uploaded_profile_v2');
        }
    };
})(vvSessionStorage);

window.vvCommon = (function(window) {
    function getTermsOfService(region) {
        var termsByRegion = {
            en: '/terms/terms-of-service.html?_hv=80fdc6b',
            kr: '/terms/kr-terms-of-service.html?_hv=0db028e',
            wooof: '/terms/wooof-terms-of-service.html?_hv=6d35dd2'
        };

        if (region in termsByRegion)
            return termsByRegion[region];
        return termsByRegion.en;
    }

    function openPopup(url, name, options, closeCallback) {
        var popup = window.open(url, name, options);
        var interval = window.setInterval(function() {
            try {
                if (popup == null || popup.closed) {
                    window.clearInterval(interval);
                    closeCallback(popup);
                }
            }
            catch (e) {
            }
        }, 1000);
        return popup;
    }

    function getContactUrl(region) {
        var contactByGlobal = 'https://docs.google.com/a/vonvon.me/forms/d/1Vkf-DwyBaHinhxfNB5kQ-K5-G0r7uiKPz3wGeF2zqpI/edit?usp=sharing';
        var contactByRegion = {
            cn: 'mailto:china@vonvon.me',
            en: 'https://docs.google.com/forms/d/e/1FAIpQLScQElQUuHYXTdcOSK1kL6qrTGzlmW6ZPFjXc-aZLnTEF_8uHA/viewform',
            fr: 'https://goo.gl/forms/OgtKrb8HV7U3HSs12',
            kr: 'https://docs.google.com/a/vonvon.me/forms/d/e/1FAIpQLScunivIA8wox5KvVHKfZepbyCFA2LJa31824Kn3cWRubLnifw/viewform',
            tw: 'https://docs.google.com/forms/d/e/1FAIpQLSfQ_n48oDTyNGKK8UKt4xGk4aAnO3j7vcIsXdZDUEYlE2Uieg/viewform',
            jp: 'https://docs.google.com/forms/d/e/1FAIpQLSfNIzj0wSrfg5ogRW9aZHIGxf7PV0TYPps0cd44Y7fqHgsolw/viewform',
            wooof: 'https://docs.google.com/forms/d/1PbD6BMxJGVVixZbfy1AVBar7wgU9K8vruCRaCE8Asug/viewform'
        };

        if (region in contactByRegion)
            return contactByRegion[region];

        return contactByGlobal;
    }

    function getContactEmail(region) {
        var contactByGlobal = 'contact@vonvon.me';
        var contactByRegion = {
            cn: 'china@vonvon.me',
            en: 'contact@ascending.media',
            kr: 'contact@ascending.media',
            tw: 'taiwan@vonvon.me',
            jp: 'contact@ascending.media',
            wooof: 'en-contact@vonvon.me'
        };

        if (region in contactByRegion)
            return contactByRegion[region];

        return contactByGlobal;
    }

    return {
        getTermsOfService: getTermsOfService,
        getContactUrl: getContactUrl,
        getContactEmail: getContactEmail,
        openPopup: openPopup
    };
})(window);

window.popupLayer = (function(window, $) {
    var currentPopup = null;
    function open($layer, onclose, oncancel) {
        if (currentPopup != null) {
            var cancelled = false;
            if (currentPopup.oncancel != null)
                cancelled = currentPopup.oncancel();

            if (cancelled) {
                console.warn('cannot cancel current popup');
                return false;
            }
        }

        currentPopup = {
            $layer: $layer,
            onclose: onclose,
            oncancel: oncancel || onclose
        };

        $layer.show();
        $('body').addClass('layer-open');
        return true;
    }

    function close() {
        if (currentPopup != null) {
            var prevented = false;
            if (currentPopup.onclose != null)
                prevented = currentPopup.onclose();

            if (prevented) {
                console.log('closing popup is prevented');
                return false;
            }

            currentPopup.$layer.hide();
            $('body').removeClass('layer-open');
            currentPopup = null;
        }
        return true;
    }

    function cancel() {
        if (currentPopup != null) {
            var prevented = false;
            if (currentPopup.oncancel != null)
                prevented = currentPopup.oncancel();

            if (prevented) {
                console.log('cancelling popup is prevented');
                return false;
            }

            currentPopup.$layer.hide();
            $('body').removeClass('layer-open');
            currentPopup = null;
        }
        return true;
    }

    return {
        open: open,
        close: close,
        cancel: cancel
    };
})(window, window.jQuery);

window.regionLayer = (function(window, $) {
    function open() {
        $('.region-layer').show();
        popupLayer.open($('.region-layer-bg'), function() {
            $('.region-layer').hide();
        });
    }

    return {
        open: open
    };
})(window, window.jQuery);

// polyfills
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position){
      position = position || 0;
      return this.substr(position, searchString.length) === searchString;
  };
}
